import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { LangProvider } from "../contexts/LangContext";
import { ResetPasswordPage } from "../pages/ResetPasswordPage";

export const Route = createFileRoute("/reset-password")({
  head: () => ({
    meta: [{ title: "Yangi parol — Lotin.uz" }],
    htmlProps: { lang: "uz-Latn" },
  }),
  component: ResetPassword,
});

function ResetPassword() {
  const { i18n } = useTranslation();
  useEffect(() => {
    document.documentElement.lang = "uz-Latn";
    if (i18n?.changeLanguage) i18n.changeLanguage("default");
  }, [i18n]);
  return (
    <LangProvider lang={"uz-Latn"}>
      <ResetPasswordPage />
    </LangProvider>
  );
}
